import React, { useState } from 'react';
import { JobMemberResponse } from '@doda/api-client/aspida/@types';
import { Text } from '@doda/io-react/common';
import { useDisclosure } from '@doda/common/src/hooks/useDisclosure';
import { ModalOverlay } from 'components/ModalOverlay';
import styles from './index.module.scss';
import { SectionTitle } from '../../SectionTitle';
import { MembersModal } from './MembersModal';

// メンバーの画像がない場合に表示するダミー画像
export const DUMMY_IMAGE = '/DodaFront/Html/images/img_recruiter_001.png';

/**
 * TeamMembersProps
 */
interface TeamMembersProps {
  members: JobMemberResponse[];
}

/** 一緒に働くメンバー 一覧 */
export const TeamMembers: React.FC<TeamMembersProps> = ({ members }) => {
  const [selectedMemberId, selectMemberId] = useState('1');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const onClickMember = (id: string) => () => {
    selectMemberId(id);
    onOpen();
  };

  return (
    <>
      <div className={styles['jobSearchDetail-teamMembers']}>
        <SectionTitle mb="M">一緒に働くメンバー</SectionTitle>
        <ul className={styles['jobSearchDetail-teamMembers__list']}>
          {members.map((member) => (
            <TeamMember
              key={member.id}
              onClick={onClickMember(member.id as string)}
              /* eslint-disable-next-line react/jsx-props-no-spreading */
              {...member}
            />
          ))}
        </ul>
      </div>
      <ModalOverlay show={isOpen} onClickOverlay={onClose}>
        <MembersModal
          members={members}
          onClose={onClose}
          initialMemberId={selectedMemberId}
        />
      </ModalOverlay>
    </>
  );
};

/**
 * TeamMemberProps
 */
interface TeamMemberProps extends Omit<JobMemberResponse, 'position'> {
  onClick: () => void;
}

/** 一緒に働くメンバー カード */
const TeamMember: React.FC<TeamMemberProps> = ({
  department,
  name,
  imageData,
  imageContentType,
  onClick,
}) => {
  return (
    <li className={styles['jobSearchDetail-teamMember']}>
      <button
        type="button"
        className={styles['jobSearchDetail-teamMember__container']}
        onClick={onClick}
      >
        <div className={styles['jobSearchDetail-teamMember__imageContainer']}>
          <img
            className={styles['jobSearchDetail-teamMember__image']}
            src={
              imageData
                ? `data:${imageContentType};base64,${imageData}`
                : DUMMY_IMAGE
            }
            alt=""
          />
        </div>

        <Text color="black_pc" size="11" style={{ marginTop: '8px' }}>
          {department}
        </Text>
        <Text color="blue" weight="bold" style={{ marginTop: '4px' }}>
          {name}
        </Text>
      </button>
    </li>
  );
};
